import BaseApi from './BaseApi';
import IModelOwner from 'src/models/IOwner';
// import OwnerIndividual from 'src/models/tract_detail/add_ownership_revised/OwnerIndividual';
import AddOwner from 'src/models/tract_detail/add_ownership_revised/AddOwner';
import OwnerIndividual from 'src/models/tract_detail/add_ownership_revised/OwnerIndividual';
import OwnerTrust from 'src/models/tract_detail/add_ownership_revised/OwnerTrust';
import OwnerBusiness from 'src/models/tract_detail/add_ownership_revised/OwnerBusiness';
import OwnerBOLM from 'src/models/tract_detail/add_ownership_revised/OwnerBOLM';
import OwnerRAL from 'src/models/tract_detail/add_ownership_revised/OwnerRAL';
import OwnerStateLand from 'src/models/tract_detail/add_ownership_revised/OwnerStateLand';
import MergeContainer from 'src/models/MergeContainer';

export interface IOwner {
    getOwners(projectId: number): Promise<object>;
    mergeContainer(clientnumber: number, projectNumber: number, mergeContainer: MergeContainer, jwt: string): Promise<object>;
    changeIndividualPrimary(owner: OwnerIndividual, jwt: string): Promise<object>;
    changeTrustPrimary(owner: OwnerTrust, jwt: string): Promise<object>;
    changeBusinessPrimary(owner: OwnerBusiness, jwt: string): Promise<object>;
    changeGovBLMPrimary(owner: OwnerBOLM, jwt: string): Promise<object>;
    changeGovRALPrimary(owner: OwnerRAL, jwt: string): Promise<object>;
    changeGovStatePrimary(owner: OwnerStateLand, jwt: string): Promise<object>;
    separateIndividualDeviation(clientNumber: number, projectNumber: number, owner: OwnerIndividual, jwt: string): Promise<object>;
    separateTrustDeviation(clientNumber: number, projectNumber: number, owner: OwnerTrust, jwt: string): Promise<object>;
    separateBusinessDeviation(clientNumber: number, projectNumber: number, owner: OwnerBusiness, jwt: string): Promise<object>;
    separateGovBLMDeviation(clientNumber: number, projectNumber: number, owner: OwnerBOLM, jwt: string): Promise<object>;
    separateGovRALDeviation(clientNumber: number, projectNumber: number, owner: OwnerRAL, jwt: string): Promise<object>;
    separateGovStateDeviation(clientNumber: number, projectNumber: number, owner: OwnerStateLand, jwt: string): Promise<object>;
    getOwnerDetails(projectId: number, ownerId: number, containerId: number, type: string, jwt: string): Promise<object>;
    updateIndividualOwner(clientNumber: number, projectNumber: number, ownerId: number, owner: IModelOwner, jwt: string): Promise<object>;
    updateTrustOwner(clientNumber: number, projectNumber: number, ownerId: number, owner: IModelOwner, jwt: string): Promise<object>;
    updateBusinessOwner(clientNumber: number, projectNumber: number, ownerId: number, owner: IModelOwner, jwt: string): Promise<object>;
    updateGovBOLMOwner(clientNumber: number, projectNumber: number, ownerId: number, owner: IModelOwner, jwt: string): Promise<object>;
    updateGovRALOwner(clientNumber: number, projectNumber: number, ownerId: number, owner: IModelOwner, jwt: string): Promise<object>;
    updateGovStateLandOwner(clientNumber: number, projectNumber: number, ownerId: number, owner: IModelOwner, jwt: string): Promise<object>;
    updateJointTenantOwner(clientNumber: number, projectNumber: number, ownerId: number, owner: IModelOwner, jwt: string): Promise<object>;
    addDeviation(clientNumber: number, projectNumber: number, addOwnership: AddOwner, jwt: string): Promise<object>;
    createBusinessOwner(clientNumber: number, projectNumber: number, owner: IModelOwner, jwt: string): Promise<object>;
    getOwnerInfo(clientNumber: number, projectNumber: number, ownerLookUpId: number, jwt: string): Promise<object>;
}

export default class Owner extends BaseApi implements IOwner {
    constructor(baseURL: string) {
        super(baseURL);
    }

    getOwners(projectId: number): Promise<object> {
        throw new Error('Method not implemented.');
    }
    getOwnerDetails = (projectId: number, ownerId: number, containerId: number, type: string, jwt: string) => {
        // return this.mockTract.getOwnerDetails(projectId, ownerId, jwt);
        return this.getRequest(`${this.baseUrl}v1.0/projects/${projectId}/owners/${ownerId}/${containerId}/${type}`, jwt);
    };
    mergeContainer = (clientNumber: number, projectNumber: number, mergeContainer: MergeContainer, jwt: string) => {
        // tslint:disable-next-line:max-line-length
        return this.postRequest(`${this.baseUrl}v1.0/clients/${clientNumber}/projects/${projectNumber}/owners/merge`, mergeContainer, jwt);
    };
    changeIndividualPrimary = (owner: OwnerIndividual, jwt: string) => {
        return this.postRequest(`${this.baseUrl}v1.0/owners/individual/change-primary`, owner, jwt);
    };
    changeTrustPrimary = (owner: OwnerTrust, jwt: string) => {
        return this.postRequest(`${this.baseUrl}v1.0/owners/trust/change-primary`, owner, jwt);
    };
    changeBusinessPrimary = (owner: OwnerBusiness, jwt: string) => {
        return this.postRequest(`${this.baseUrl}v1.0/owners/business/change-primary`, owner, jwt);
    };
    changeGovBLMPrimary = (owner: OwnerBOLM, jwt: string) => {
        return this.postRequest(`${this.baseUrl}v1.0/owners/gov-blm/change-primary`, owner, jwt);
    };
    changeGovRALPrimary = (owner: OwnerRAL, jwt: string) => {
        return this.postRequest(`${this.baseUrl}v1.0/owners/gov-ral/change-primary`, owner, jwt);
    };
    changeGovStatePrimary = (owner: OwnerStateLand, jwt: string) => {
        return this.postRequest(`${this.baseUrl}v1.0/owners/gov-state/change-primary`, owner, jwt);
    };
    separateIndividualDeviation = (clientNumber: number, projectNumber: number, owner: OwnerIndividual, jwt: string) => {
        return this.postRequest(
            `${this.baseUrl}v1.0/clients/${clientNumber}/projects/${projectNumber}/owners/individual/separate-deviation`,
            owner,
            jwt
        );
    };
    separateTrustDeviation = (clientNumber: number, projectNumber: number, owner: OwnerTrust, jwt: string) => {
        return this.postRequest(`${this.baseUrl}v1.0/clients/${clientNumber}/projects/${projectNumber}/owners/trust/separate-deviation`, owner, jwt);
    };
    separateBusinessDeviation = (clientNumber: number, projectNumber: number, owner: OwnerBusiness, jwt: string) => {
        return this.postRequest(
            `${this.baseUrl}v1.0/clients/${clientNumber}/projects/${projectNumber}/owners/business/separate-deviation`,
            owner,
            jwt
        );
    };
    separateGovBLMDeviation = (clientNumber: number, projectNumber: number, owner: OwnerBOLM, jwt: string) => {
        return this.postRequest(
            `${this.baseUrl}v1.0/clients/${clientNumber}/projects/${projectNumber}/owners/gov-blm/separate-deviation`,
            owner,
            jwt
        );
    };
    separateGovRALDeviation = (clientNumber: number, projectNumber: number, owner: OwnerRAL, jwt: string) => {
        return this.postRequest(
            `${this.baseUrl}v1.0/clients/${clientNumber}/projects/${projectNumber}/owners/gov-ral/separate-deviation`,
            owner,
            jwt
        );
    };
    separateGovStateDeviation = (clientNumber: number, projectNumber: number, owner: OwnerStateLand, jwt: string) => {
        return this.postRequest(
            `${this.baseUrl}v1.0/clients/${clientNumber}/projects/${projectNumber}/owners/gov-state/separate-deviation`,
            owner,
            jwt
        );
    };
    updateIndividualOwner = (clientNumber: number, projectNumber: number, ownerId: number, owner: IModelOwner, jwt: string) => {
        return this.putRequest(
            `${this.baseUrl}v1.0/clients/${clientNumber}/projects/${projectNumber}/owners/${ownerId}/edit/owner-individual`,
            owner,
            jwt
        );
    };
    updateTrustOwner = (clientNumber: number, projectNumber: number, ownerId: number, owner: IModelOwner, jwt: string) => {
        return this.putRequest(
            `${this.baseUrl}v1.0/clients/${clientNumber}/projects/${projectNumber}/owners/${ownerId}/edit/owner-trust`,
            owner,
            jwt
        );
    };
    updateBusinessOwner = (clientNumber: number, projectNumber: number, ownerId: number, owner: IModelOwner, jwt: string) => {
        return this.putRequest(
            `${this.baseUrl}v1.0/clients/${clientNumber}/projects/${projectNumber}/owners/${ownerId}/edit/owner-business`,
            owner,
            jwt
        );
    };
    updateGovBOLMOwner = (clientNumber: number, projectNumber: number, ownerId: number, owner: IModelOwner, jwt: string) => {
        return this.putRequest(
            `${this.baseUrl}v1.0/clients/${clientNumber}/projects/${projectNumber}/owners/${ownerId}/edit/owner-gov-bolm`,
            owner,
            jwt
        );
    };
    updateGovRALOwner = (clientNumber: number, projectNumber: number, ownerId: number, owner: IModelOwner, jwt: string) => {
        return this.putRequest(
            `${this.baseUrl}v1.0/clients/${clientNumber}/projects/${projectNumber}/owners/${ownerId}/edit/owner-gov-ral`,
            owner,
            jwt
        );
    };
    updateGovStateLandOwner = (clientNumber: number, projectNumber: number, ownerId: number, owner: IModelOwner, jwt: string) => {
        return this.putRequest(
            `${this.baseUrl}v1.0/clients/${clientNumber}/projects/${projectNumber}/owners/${ownerId}/edit/owner-gov-state-land`,
            owner,
            jwt
        );
    };
    updateJointTenantOwner = (clientNumber: number, projectNumber: number, ownerId: number, owner: IModelOwner, jwt: string) => {
        console.log('calling updateJointTenantOwner', owner);
        return this.putRequest(
            `${this.baseUrl}v1.0/clients/${clientNumber}/projects/${projectNumber}/owners/${ownerId}/edit/owner-joint-tenant`,
            owner,
            jwt
        );
    };
    addDeviation = (clientNumber: number, projectNumber: number, addOwnership: AddOwner, jwt: string): Promise<object> => {
        return this.postRequest(`${this.baseUrl}v1.0/clients/${clientNumber}/projects/${projectNumber}/owners/add-deviation`, addOwnership, jwt);
    };
    createBusinessOwner = (clientNumber: number, projectNumber: number, owner: IModelOwner, jwt: string): Promise<object> => {
        return this.postRequest(`${this.baseUrl}v1.0/clients/${clientNumber}/projects/${projectNumber}/owners/business`, owner, jwt);
    };
    getOwnerInfo = (clientNumber: number, projectNumber: number, ownerLookUpId: number, jwt: string): Promise<object> => {
        return this.getRequest(`${this.baseUrl}v1.0/clients/${clientNumber}/projects/${projectNumber}/owners/${ownerLookUpId}`, jwt);
    };
}



// WEBPACK FOOTER //
// ./src/api/Owner.ts